module.exports = __webpack_public_path__ + "img/xinchongjiaxcxcode.72e3883b.jpg";